"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfirmForgotPasswordMutation = exports.useForgotPasswordMutation = exports.useHeartbeatMutation = exports.useRefreshMutation = exports.useLoginMutation = exports.useMeQuery = exports.authApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.authApi = (0, react_1.createApi)({
    reducerPath: "authApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["auth"],
    endpoints: function (builder) { return ({
        me: builder.query({
            query: function () { return "/v1/user/me"; },
            providesTags: ["auth"],
        }),
        login: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/user/log-in",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["auth"],
        }),
        refresh: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/user/refresh",
                method: "POST",
                body: obj,
            }); },
        }),
        heartbeat: builder.mutation({
            query: function () { return ({
                url: "/v1/session/heartbeat",
                method: "POST",
            }); },
        }),
        logout: builder.mutation({
            query: function () { return ({
                url: "/v1/user/logout",
                method: "POST",
            }); },
        }),
        forgotPassword: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/user/forgot-password",
                method: "POST",
                body: obj,
            }); },
        }),
        confirmForgotPassword: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/user/confirm-forgot-password",
                method: "POST",
                body: obj,
            }); },
        }),
    }); },
});
exports.useMeQuery = exports.authApi.useMeQuery, exports.useLoginMutation = exports.authApi.useLoginMutation, exports.useRefreshMutation = exports.authApi.useRefreshMutation, exports.useHeartbeatMutation = exports.authApi.useHeartbeatMutation, exports.useForgotPasswordMutation = exports.authApi.useForgotPasswordMutation, exports.useConfirmForgotPasswordMutation = exports.authApi.useConfirmForgotPasswordMutation;
